import { render, staticRenderFns } from "./BrandingTab.vue?vue&type=template&id=4b74f062&scoped=true"
import script from "./BrandingTab.vue?vue&type=script&lang=js"
export * from "./BrandingTab.vue?vue&type=script&lang=js"
import style0 from "./BrandingTab.vue?vue&type=style&index=0&id=4b74f062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b74f062",
  null
  
)

export default component.exports